export const MODEL_FORMATS = [
  "glb",
  "gltf",
  "obj",
  "stl",
  "ply",
  "fbx",
] as const;

export type ModelFormat = (typeof MODEL_FORMATS)[number];

const MODEL_LABELS: Record<ModelFormat, string> = {
  glb: "GLB",
  gltf: "glTF",
  obj: "OBJ",
  stl: "STL",
  ply: "PLY",
  fbx: "FBX",
};

export function modelFormat(name: string): ModelFormat | undefined {
  const extension = name.split(".").pop()?.toLowerCase();
  return MODEL_FORMATS.find((format) => format === extension);
}

export function modelFormatLabel(format: ModelFormat) {
  return MODEL_LABELS[format];
}

export function isModelFile(file: Pick<File, "name">) {
  return !!modelFormat(file.name);
}

/**
 * A lone .gltf upload can only be opened when its buffers and images are data
 * URIs. Companion files are intentionally rejected rather than guessed by
 * filename or fetched from another origin.
 */
export function externalGltfResources(text: string) {
  const parsed = JSON.parse(text) as {
    buffers?: Array<{ uri?: unknown }>;
    images?: Array<{ uri?: unknown }>;
  };
  const resources = [...(parsed.buffers ?? []), ...(parsed.images ?? [])];
  return resources
    .map((resource) => resource.uri)
    .filter(
      (uri): uri is string =>
        typeof uri === "string" &&
        !uri.trim().toLowerCase().startsWith("data:"),
    );
}
